import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";

export default function AboutPage() {
  useSeo({
    title: "À propos – Pdf-Convert | pdf-convert.fr",
    description:
      "Découvrez Pdf-Convert : un site d’outils gratuits pour convertir et compresser des fichiers PDF et images, sans envoi de données.",
    canonical: "https://pdf-convert.fr/a-propos",
  });

  // Breadcrumb
  const breadcrumbJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Accueil",
          item: "https://pdf-convert.fr/home",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "À propos",
          item: "https://pdf-convert.fr/a-propos",
        },
      ],
    }),
    []
  );

  useJsonLd("breadcrumb-about", breadcrumbJsonLd);

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>À propos de Pdf-Convert</h1>

      <p>
        <strong>Pdf-Convert</strong> est un site d’outils en ligne conçu pour
        faciliter la conversion et la compression de fichiers PDF et images,
        directement depuis votre navigateur.
      </p>

      <p>
        L’objectif est simple : proposer des outils rapides, gratuits et
        accessibles à tous, sans inscription et sans installation de logiciel.
      </p>

      <h2>🔒 Respect de la confidentialité</h2>
      <p>
        Tous les traitements (conversion PDF, images, compression) sont réalisés
        <strong> localement sur votre appareil</strong>. Aucun fichier n’est
        envoyé, stocké ou analysé sur un serveur distant.
      </p>

      <h2>⚙️ Outils proposés</h2>
      <ul>
        <li>Conversion de PDF en images JPG ou PNG</li>
        <li>Conversion d’images en PDF au format A4</li>
        <li>Réduction du poids des images (JPG / WebP)</li>
      </ul>

      <h2>📱 Accessibilité</h2>
      <p>
        Pdf-Convert est utilisable aussi bien sur ordinateur que sur mobile. Les
        performances peuvent varier selon la puissance de l’appareil et la
        taille des fichiers traités.
      </p>

      <h2>💡 Pourquoi Pdf-Convert ?</h2>
      <p>
        De nombreux outils en ligne imposent des limites, des inscriptions ou
        l’envoi de fichiers sensibles. Pdf-Convert privilégie la simplicité, la
        transparence et la confidentialité.
      </p>

      <p style={{ marginTop: 24 }}>
        Pour plus d’informations, consultez la{" "}
        <a href="/confidentialite">politique de confidentialité</a> ou la{" "}
        <a href="/faq">FAQ</a>.
      </p>
    </main>
  );
}
